(function RCC_ATC_PRO_V1() {
  "use strict";

  /* ------------------------------------
     PRODUCT HANDLES TO HIDE QUICK ADD FOR
  ------------------------------------ */
  const HIDDEN_QUICK_ADD_HANDLES = ["mint-insert"];

  /* ------------------------------------
     CART DRAWER OPENER
  ------------------------------------ */
  function openCartDrawer() {
    const drawer = document.querySelector("cart-drawer");
    if (drawer?.open) {
      drawer.open();
      return;
    }

    if (window.cartDrawer?.open) {
      window.cartDrawer.open();
      return;
    }

    document
      .querySelector(".header__icon--cart, [href='/cart']")
      ?.click();
  }

  /* ------------------------------------
     EXTRACT PRODUCT HANDLE FROM URL
  ------------------------------------ */
  function getHandleFromUrl(productUrl) {
    if (!productUrl) return null;
    // strips query string / trailing slashes too
    return productUrl.split("/products/")[1]?.split("?")[0]?.split("/")[0] || null;
  }

  /* ------------------------------------
     CHECK VARIANT STOCK
  ------------------------------------ */
  function checkVariantStock(button) {
    const productUrl = button.dataset.url;
    if (!productUrl) return;

    const handle = getHandleFromUrl(productUrl);
    if (!handle) return;

    // ✅ Hide quick add button entirely for specific handles (e.g. mint-insert)
    if (HIDDEN_QUICK_ADD_HANDLES.includes(handle)) {
      button.style.display = "none";
      return;
    }

    fetch(`/products/${handle}.js`)
      .then(res => (res.ok ? res.json() : null))
      .then(product => {
        if (!product?.variants) return;

        // ✅ check ANY variant available
        const hasAvailableVariant = product.variants.some(v => v.available);

        if (hasAvailableVariant) {
          // ✔ show quick add
          button.style.display = "inline-block";
          button.textContent = "Quick Add";
          button.classList.remove("is-sold-out");
        } else {
          // ❌ hide or disable
          button.textContent = "Out of Stock";
          button.classList.add("is-sold-out");
          button.disabled = true;
        }
      })
      .catch(() => {});
  }

  /* ------------------------------------
     RCC CUSTOM ATC COMPONENT
  ------------------------------------ */
  class RCC_ATC_Pro_Component extends HTMLElement {
    set product(product) {
      this.productData = product || {};
      this.render();
    }

    render() {
      this.innerHTML = "";

      const product = this.productData;
      const variants = product.variants || [];
      const variant =
        variants.find(v => String(v.id) === String(product.variantId)) ||
        variants[0] ||
        {};

      const hasViewDetailTag = Array.isArray(product.tags)
        ? product.tags.includes("rcc-view-detail-button")
        : String(product.tags || "")
            .split(",")
            .map(t => t.trim())
            .includes("rcc-view-detail-button");

      const variantId = String(variant.id || "").includes("gid://")
        ? variant.id.split("/").pop()
        : variant.id;

      // ✅ Also catch handle directly off product data, before even building the button
      const handleFromProduct = product.handle || getHandleFromUrl(product.url);
      if (handleFromProduct && HIDDEN_QUICK_ADD_HANDLES.includes(handleFromProduct)) {
        return; // render nothing for this product
      }

      const button = document.createElement("button");
      button.type = "button";
      button.className = "rcc-atc-pro-btn";
      button.textContent = hasViewDetailTag ? "View Product" : "Quick Add";

      button.dataset.variantId = variantId || "";
      button.dataset.isViewDetail = hasViewDetailTag ? "1" : "0";
      button.dataset.url = product.url || "#";

      this.appendChild(button);

      /* Async stock check (safe) */
      checkVariantStock(button);
    }
  }

  if (!customElements.get("rcc-custom-component-atc")) {
    customElements.define(
      "rcc-custom-component-atc",
      RCC_ATC_Pro_Component
    );
  }

  /* ------------------------------------
     GLOBAL CLICK HANDLER
  ------------------------------------ */
  document.addEventListener(
    "click",
    function (event) {
      const button = event.target.closest(".rcc-atc-pro-btn");
      if (!button) return;

      /* Sold out → no action */
      if (button.dataset.isSoldOut === "1") return;

      event.preventDefault();
      event.stopImmediatePropagation();

      /* Subscription → PDP */
      if (button.dataset.isViewDetail === "1") {
        window.location.href = button.dataset.url;
        return;
      }

      /* One-time → AJAX add */
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }]
        })
      })
        .then(res => {
          if (!res.ok) throw new Error("ATC blocked");
          return res.json();
        })
        .then(() => {
          openCartDrawer();
        })
        .catch(() => {});
    },
    true
  );
})();